import React from 'react';
import './Clientes-Modal.css'; // Asegúrate de que este CSS contenga los estilos mejorados
//import inversor from './assets/Humilladero/inversor.jpeg';
import DancarMp4 from './assets/Coomultrup/poster.mp4';

const Coomultrup = () => {
  return (
    <div>
      <div className="container">
        <h2>
        ✅ Proyecto: Supermercado Coomultrup – Pamplona🌞✨{' '}
         
        </h2>
        <p>
         
          <video controls>
            <source src={DancarMp4} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
         

        

   <span className="highlight">
            {' '}
           Energía limpia para un comercio regional que impulsa el desarrollo local.
          </span>

<br/><br/>En el Supermercado Coomultrup, uno de los establecimientos comerciales más reconocidos y concurridos de Pamplona, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 52.91 kWp, conformado por 74 paneles solares de alta eficiencia y un inversor multicanal de 50 kW con Smart Manager.

<br/><br/>Este sistema permite gestionar de forma inteligente y segura el consumo energético del supermercado, optimizando el rendimiento del equipo, priorizando el ahorro y garantizando una operación estable incluso en horas de mayor demanda eléctrica.

<br/><br/>Los objetivos de este proyecto fueron:<br/>

<br/>✔ Reducir los costos asociados al consumo eléctrico del establecimiento.
<br/>✔ Implementar una solución sostenible que disminuya la huella ambiental del supermercado.
<br/>✔ Garantizar energía continua para refrigeración, iluminación y equipos comerciales de uso constante.

<br/><br/>Hoy, el Supermercado Coomultrup genera su propia energía limpia, reduciendo sus costos mensuales de electricidad y mejorando la eficiencia operativa del negocio. Este ahorro le permite reinvertir en mejoras para sus clientes, aportando al crecimiento regional.

<br/><br/>Con esta instalación, Coomultrup se consolida como un ejemplo de innovación y responsabilidad empresarial en Pamplona, demostrando que es posible ser rentable y sostenible al mismo tiempo.

<br/> <span className="highlight"><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span><br/><br/>

🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<br/><br/>Una decisión empresarial inteligente que combina ahorro, sostenibilidad y compromiso con el desarrollo local.

        </p>
      </div>
    </div>
  );
};

export default Coomultrup;
